import createRemoteObjectResourceReducer from "./helpers/createRemoteObjectResourceReducer";

export const multipleAssetPermission = createRemoteObjectResourceReducer(
  "MULTIPLE_ASSET_PERMISSIONS"
);
